import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchAllCategories } from 'services';
import { showError, sortArray } from 'utils';

const CategoriesDropwdown = props => {
  const [categories, setCategories] = useState<{ objectId: string; description: string;slug: string }[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const {
    componentRef,
    value,
    disabled,
    onSelect,
    isSlug,
  } = props;
  
  const fetchAllCategoriesFn = async () => {
    try {
      const response = await fetchAllCategories();
      setCategories(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCategoriesFn();
  }, []);

  const getOptions = () => sortArray(categories, 'description').map((category, i) => (
    <option key={i} value={category.objectId}>{category.description}</option>
  ));

  const getSlugOptions = () => sortArray(categories, 'description').map((category, i) => (
    <option key={i} value={category.slug}>{category.slug}</option>
  ));

  const handleSelect = (id: string) => {
    if (!onSelect) return;
    if(isSlug){
      const category= _.find(categories ,['slug',id]);
      onSelect(category?.slug);
    }else{
      const category = _.find(categories ,['objectId',id]);
      onSelect(category);
    }
  };

  const getDropDownOptions=()=>{
    if(isSlug){
      return categories.length && getSlugOptions();
    } else{
      return  categories.length && getOptions();
    }
  };

  return (
    <>
      <select
        name={'category'}
        ref={componentRef && componentRef}
        className={'form-control'}
        value={value}
        disabled={!categories.length || loading || disabled}
        onChange={e => handleSelect(e.target.value)}
      >
        <option value={''} hidden={!!value}>Choose a category</option>
        {getDropDownOptions()}
      </select>
    </>
  );
};

export default CategoriesDropwdown;